module.exports = __webpack_public_path__ + "img/p4.adace1ab.png";